import React, { useEffect, useState } from 'react';
import { Spinner } from '../../../../common';
import ResponseForm from './ResponseForm.jsx';
import { AppBarCMS } from '../../../../basic';
import { useToastMessages } from '../../../../../hooks/useToastMessages.jsx';
import { useParams, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import {
  useGetPollResponsesQuery,
  useSavePollResponsesMutation,
} from '../../../../../redux/services/polls';

const ResponseEdit = ({ mode }) => {
  const { id } = useParams();
  const { t } = useTranslation();
  const navigate = useNavigate();
  const isCreate = mode === 'create';
  const isEdit = !isCreate;

  useEffect(() => {
    document.title = isEdit
      ? t('Úprava kolekcie odpovedí') + ' - FRI CMS'
      : t('Pridanie kolekcie odpovedí') + ' - FRI CMS';
  }, []); // Runs on mount

  const [toastId, setToastId] = useState('');

  const { data, isLoading } = useGetPollResponsesQuery(id, { skip: isCreate });

  const {
    saveSuccess: showSaveSuccess,
    saveFailed,
    infoMessage,
    dismissToast,
  } = useToastMessages();

  const [savePollResponse] = useSavePollResponsesMutation();

  useEffect(() => {
    return () => {
      if (toastId !== '') {
        dismissToast(toastId);
        setToastId('');
      }
    };
  }, []);

  const showInfoMessage = () => {
    if (!isCreate && toastId === '') {
      setToastId(
        infoMessage({
          message: t(
            'Pre uloženie zmien v odpovediach je nutné uložiť celú kolekciu.',
          ),
          key: 'CollectionEditSaveNecessary',
          duration: 0,
        }),
      );
    }
  };

  const initials = {
    name: data?.name || null,
    questions: data?.questions ? [...data.questions] : [],
    responses: data?.responses
      ? data.responses.map(({ id, name, editable }) => ({ id, name, editable }))
      : [],
  };

  return isLoading ? (
    <Spinner />
  ) : (
    <>
      <AppBarCMS
        title={
          isCreate
            ? t('Pridanie kolekcie odpovedí')
            : t('Úprava kolekcie odpovedí')
        }
        backUrl={-1}
        backUrlTooltip={t('Kolekcie odpovedí')}
        permissionsBasic={'response-collections'}
      />
      <div style={{ margin: '10px' }}>
        <ResponseForm
          pollsResponseDetail={data}
          showInfoMessage={showInfoMessage}
          isCreate={isCreate}
          initialValues={initials}
          onSubmit={async (values) => {
            if (toastId !== '') {
              dismissToast(toastId);
              setToastId('');
            }
            try {
              await savePollResponse({
                body: values,
                id: isCreate ? undefined : id,
              }).unwrap();
              showSaveSuccess();
              navigate(-1);
            } catch (err) {
              saveFailed(err);
            }
          }}
        />
      </div>
    </>
  );
};

export default ResponseEdit;
